<template>
  <b-container>
    <b-row class="my-4">
      <b-col xl="3" cols="6" order-xl="2" class="d-flex align-items-center">
        <b-button-group>
          <b-button
            class="nav-link pl-0"
            variant="link"
            :to="{ name: 'gallery' }"
          >{{ $t('gallery.tabTitle') }}</b-button>
          <b-button class="nav-link" variant="link" :to="{ name: 'map' }">{{ $t('map.tabTitle') }}</b-button>
          <b-button class="nav-link" variant="link" :to="{ name: 'list' }">{{ $t('list.tabTitle') }}</b-button>
          <b-button
            v-if="isAdmin"
            class="nav-link"
            variant="link"
            :to="{ name: 'stats' }"
          >{{ $t('stats.tabTitle') }}</b-button>
        </b-button-group>
      </b-col>
      <b-col xl="3" cols="6" order-xl="3" class="d-flex justify-content-end align-items-center">
        <b-button size="sm" variant="primary" :to="{ name: 'new' }" v-if="isAdmin">
          {{
          $t("general.newReference")
          }}
        </b-button>
      </b-col>
      <b-col xl="6" cols="12" order-xl="1">
        <b-input-group v-if="!disableSearchAndFilter" class="searchfield-group">
          <span class="h5">
            <b-icon icon="search" />
          </span>
          <b-form-input class="searchfield" v-model="query" :placeholder="$t('search')"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="!disableSearchAndFilter">
      <b-col sm="2">
        <b-form-select v-model="selectedProductFamily" :options="productFamilies">
        </b-form-select>
      </b-col>
      <b-col sm="2">
        <b-form-select v-model="year" :options="yearOptions" />
      </b-col>
    </b-row>
    <router-view />
  </b-container>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { productFamilies } from "@/productFamilies.js";
import currentUserMixin from "../current-user.js";

export default {
  props: {
    disableSearchAndFilter: Boolean,
  },
  data: () => ({
    query: "",
    selectedProductFamily: null,
    year: null,
  }),
  mixins: [currentUserMixin],
  computed: {
    yearOptions() {
      let yearArray = [];
      const noYearFilter = {
        text: this.$t("noYearFilter"),
        value: null,
      };
      yearArray.push(noYearFilter);

      let actualYear = new Date().getFullYear();

      for (let index = 2010; index <= actualYear; index++) {
        yearArray.push(index);
      }

      return yearArray;
    },
    productFamilies() {
      return [
        {
          text: this.$t("noProductFamilyFilter"),
          value: null,
        },
        ...productFamilies,
      ];
    },
  },
  methods: {
    ...mapMutations("references", ["setFetchParams"]),
    ...mapActions("references", ["fetchReferences"]),
    updateFilter() {
      const filter = {};
      if (this.selectedProductFamily) {
        filter.productFamily = this.selectedProductFamily;
      }
      if (this.year) {
        filter.year = this.year;
      }
      this.setFetchParams({
        filter,
      });
      this.fetchReferences();
    },
  },
  watch: {
    year() {
      this.updateFilter();
    },
    selectedProductFamily() {
      this.updateFilter();
    },
    query(value) {
      this.setFetchParams({
        query: value,
        queryLanguage: this.$i18n.locale,
      });
      this.fetchReferences();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";
@import "@/multiselect.scss";

.nav-link.active {
  filter: brightness(0.4);
}

.custom-select {
  width: auto;
  border: none;
  background-image:
    linear-gradient(45deg, transparent 50%, rgb(70, 70, 70) 50%),
    linear-gradient(135deg, rgb(70, 70, 70) 50%, transparent 50%);
  background-position:
    calc(100% - 15px) calc(1em + 1px),
    calc(100% - 10px) calc(1em + 1px),
    100% 0;
  background-size:
    5px 4px,
    5px 4px,
    2.5em 2.5em;
  background-repeat: no-repeat;
}
</style>